angular.module('zc.core')
  .filter('gmtNotation', gmtNotation);

gmtNotation.$inject = [];
function gmtNotation() {
  return function(timezone) {
    const notation = {
      africa_johannesburg: 'South Africa',
      america_los_angeles: 'United States',
      america_new_york: 'United States',
      america_toronto: 'Canada',
      asia_bangkok: 'Thailand',
      asia_ho_chi_minh: 'Vietnam',
      asia_hong_kong: 'Hong Kong',
      asia_jakarta: 'Indonesia',
      asia_kolkata: 'India',
      asia_kuala_lumpur: 'Malaysia',
      asia_manila: 'Philippines',
      asia_seoul: 'Korea',
      asia_shanghai: 'China',
      asia_singapore: 'Singapore',
      asia_taipei: 'Taiwan',
      asia_tokyo: 'Japan',
      australia_sydney: 'Australia',
      europe_amsterdam: 'Netherlands',
      europe_berlin: 'Germany',
      europe_london: 'United Kingdom',
      europe_paris: 'France',
      europe_rome: 'Italy',
      europe_stockholm: 'Sweden',
      europe_zurich: 'Switzerland',
      pacific_auckland: 'New Zealand',
    };

    const offset = moment().tz(timezone).format('Z');
    return `${notation[timezone]} GMT${offset}`;
  };
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/filters/gmt_notation.filter.js